<div class="financials-container" id="financials">
    <div class="view-section">
        <h3 class="view-section-header">{{project.projectType.name}} Financials</h3>
        <div style="margin-left: 20px">
            <h5>Financial Notes</h5>
            @if(project.financialNotes) {
                <p>
                    {{project.financialNotes}}
                </p>
            }
            @else {
                <div>There is no information to display</div>
            }

            <app-workday-financials-panel [project]="project"></app-workday-financials-panel>
            <app-linked-workday-finance-projects-panel [project]="project"></app-linked-workday-finance-projects-panel>
            <app-estimated-costs-panel [project]="project"></app-estimated-costs-panel>

        </div>

    </div>



</div>
